import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Trash2, Loader2 } from "lucide-react";

/**
 * ConfirmSoftDelete — shared confirmation dialog for "move to recycle bin" operations.
 * Props: open, onOpenChange, onConfirm, itemLabel (optional), busy
 */
export default function ConfirmSoftDelete({ open, onOpenChange, onConfirm, itemLabel, busy, testid = "confirm-soft-delete" }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <Trash2 size={18} className="text-amber-600"/> Geri Dönüşüm Kutusuna Taşı
                    </DialogTitle>
                    <DialogDescription className="pt-3">
                        Bu kayıt geri dönüşüm kutusuna taşınacaktır. Devam etmek istiyor musunuz?
                        {itemLabel && (
                            <div className="mt-3 bg-muted border border-border rounded p-2.5 text-sm font-medium text-foreground">
                                {itemLabel}
                            </div>
                        )}
                        <div className="text-xs text-muted-foreground mt-3">
                            Bu kayıt normal listelerden gizlenecek ancak geri yüklenebilir.
                        </div>
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>Vazgeç</Button>
                    <Button variant="destructive" onClick={onConfirm} disabled={busy} data-testid={testid}>
                        {busy && <Loader2 size={14} className="mr-2 animate-spin"/>}
                        Geri Dönüşüm Kutusuna Taşı
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
